<fui-chrome-control-dropdown [title]="'fhm.chrome.button.account'">
    <fui-icon [height]="15" [icon]="'account'" [width]="18"></fui-icon>
    <div class="account">
        <div class="account-state">
            <div class="account-state-header">
                <div class="account-state-header-label">
                    <div class="account-state-header-label-title">
                        {{auth.getName()}}
                    </div>
                </div>
            </div>
            <div class="account-state-footer">
                <div class="account-state-footer-role-label">
                    <div class="account-state-footer-role-label-title">
                        {{auth.getEmail()}}
                    </div>
                </div>
            </div>
            <div class="account-state-footer">
                <div class="account-state-footer-action">
                    <fui-local-button (click)="logoutOfGoogle()" [title]="'fhm.common.label.logoutGoogle'"></fui-local-button>
                </div>
            </div>

        </div>
    </div>
</fui-chrome-control-dropdown>
